<template>
  <v-container fluid>
    <v-row justify="center">
      <v-card width="45%">
        <v-card-title>
          <h3 class="headline">{{ title }}</h3></v-card-title
        >
        <v-card-text>
          <v-divider></v-divider>

          <v-row v-if="!hasSupplierPortalUser">
            <v-col>
              <v-switch
                label="Set Usename and password manually"
                v-model="manualSet"
              />
            </v-col>
          </v-row>
          <v-row v-if="manualSet">
            <v-col>
              <v-text-field
                v-model="supplierUsername"
                label="Username"
                outlined
                dense
                required
                hide-details
              />
            </v-col>
          </v-row>
          <v-row v-if="manualSet">
            <v-col>
              <v-text-field
                v-model="supplierPassword"
                label="Password"
                outlined
                dense
                required
                type="password"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="supplierUserEmail"
                label="Email"
                outlined
                dense
                required
                type="email"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-row justify="center" align="center">
                <v-btn
                  color="primary"
                  :loading="loading"
                  @click="onGrantAccess"
                  :disabled="!grantIsValid"
                  >{{
                    hasSupplierPortalUser ? "Update" : "Grant Access"
                  }}</v-btn
                ></v-row
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ supplier }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
const GRANT_ACCESS_MUTATION = gql`
  mutation grantAccess(
    $id: ID!
    $username: String
    $password: String
    $email: String
  ) {
    grantSupplierPortalAccess(
      id: $id
      username: $username
      password: $password
      email: $email
    ) {
      success
      error
      message
    }
  }
`;
export default {
  name: "supplier-portal-settings",

  props: {
    supplierId: {
      type: String,
      default: "",
    },
    supplier: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      loading: false,
      manualSet: true,
      supplierUsername:
        this.supplier && this.supplier.supplierPortalUser
          ? this.supplier.supplierPortalUser.username
          : "",
      supplierPassword: "",
      supplierUserEmail:
        this.supplier && this.supplier.supplierPortalUser
          ? this.supplier.supplierPortalUser.email
          : "",
    };
  },

  computed: {
    grantIsValid() {
      return (
        (this.supplierUsername != "" || !this.manualSet) &&
        this.supplierUserEmail != ""
      );
    },
    hasSupplierPortalUser() {
      return this.supplier && this.supplier.supplierPortalUser != null;
    },
    title() {
      return this.hasSupplierPortalUser
        ? "Supplier Portal Settings"
        : "Grant Supplier Portal Access";
    },
  },

  methods: {
    onGrantAccess() {
      if (this.supplierId != "") {
        this.loading = true;
        //mutation to grant access
        if (!this.manualSet) {
          this.supplierUsername = "";
          this.supplierPassword = "";
        }
        this.$apollo
          .mutate({
            mutation: GRANT_ACCESS_MUTATION,
            variables: {
              id: this.supplierId,
              username: this.supplierUsername,
              password: this.supplierPassword,
              email: this.supplierUserEmail,
            },
          })
          .then((response) => {
            this.loading = false;
            if (response.data.grantSupplierPortalAccess.success) {
              this.$store.dispatch("showAppSnackbar", {
                msg: response.data.grantSupplierPortalAccess.message,
              });
            } else {
              this.$store.dispatch("showAppSnackbar", {
                msg: response.data.grantSupplierPortalAccess.error,
                color: "error",
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$store.dispatch("showAppSnackbar", {
              msg: error.message,
              color: "error",
            });
          });
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/suppliers/portal/SupplierPortalSettings.vue